import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterFeatureBase,
  CharacterFeatureSource,
} from "@dndModels";

// import { makeStyles } from '../../../../../utilities/theme_utilities';
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterFeatureSourceInput from "@dndComponents/character/features/CharacterFeatureSourceInput";
import CharacterFeatureBaseInput from "@dndComponents/character/features/CharacterFeatureBaseInput";
import FloatMenu from "@components/input/menus/FloatMenu";

interface Props {
  char: Character;
}

// const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterFeatures({
  char,
}: Props) {
  // const [loading, setLoading] = useState(false);
  // const [fetched, setFetched] = useState(false);
  const [view, setView] = useState("ALL");
  const [selected_cfs, setSelectedCFS] = useState<CharacterFeatureSource | null>(null);
  const [selected_cfb, setSelectedCFB] = useState<CharacterFeatureBase | null>(null);

  const renderClassFeatures = () => {
    return (
      <Grid container spacing={0} direction="column">
        <Grid
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            borderBottom: "1px solid"
          }}>
          Class Features
        </Grid>
        { char.spirit.classes.map((char_class) => {
          return (
            <Grid key={char_class.true_id} container spacing={0} direction="column">
              <Grid
                style={{ 
                  fontWeight: "bold", 
                  cursor: "pointer"
                }}
                onClick={() => {
                  setSelectedCFS(char_class);
                  setSelectedCFB(null);
                }}>
                { char_class.source && char_class.source.name } Features
              </Grid>
              { renderFeaturesForCFS(char_class) }
            </Grid>
          ); 
        })}
      </Grid>
    );
  }

  const renderBackgroundFeatures = () => {
    return (
      <Grid container spacing={0} direction="column">
        <Grid
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            borderBottom: "1px solid",
            cursor: "pointer"
          }}
          onClick={() => {
              setSelectedCFS(char.spirit.background);
              setSelectedCFB(null);
            }}>
          Background Traits ({ char_util.getUseName(char.spirit.background) })
        </Grid>
        { renderFeaturesForCFS(char.spirit.background) }
      </Grid>
    );
  }

  const renderRacialFeatures = () => {
    let race_name = char.sidekick ? (char.sidekick_creature ? char_util.getUseName(char.sidekick_creature) : "No Creature") : char_util.getUseName(char.spirit.race.source);
    if (race_name === "No Race" && char.c_options.races_called === "Species") {
      race_name = "No Species";
    }
    return (
      <Grid container spacing={0} direction="column">
        <Grid
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            borderBottom: "1px solid",
            cursor: "pointer"
          }}
          onClick={() => {
              setSelectedCFS(char.spirit.race);
              setSelectedCFB(null);
            }}>
          { char.c_options.races_called ? "Racial" : "Species" } Traits ({ race_name })
        </Grid>
        { renderFeaturesForCFS(char.spirit.race) }
      </Grid>
    );
  }

  const renderExtraFeatFeatures = () => {
    return (
      <Grid container spacing={0} direction="column">
        <Grid
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "blue",
            borderBottom: "1px solid"
          }}>
          Extra Feat Features
        </Grid>
        { char.spirit.extra_feats.map((char_class) => {
          return (
            <Grid key={char_class.true_id} container spacing={0} direction="column">
              <Grid
                style={{ 
                  fontWeight: "bold", 
                  color: "blue",
                  cursor: "pointer"
                }}
                onClick={() => {
                  setSelectedCFS(char_class);
                  setSelectedCFB(null);
                }}>
                { char_class.source && char_class.source.name } Features
              </Grid>
              { renderFeaturesForCFS(char_class) }
            </Grid>
          );  
        })}
      </Grid>
    );
  }

  const renderGiftFeatures = () => {
    return (
      <Grid container spacing={0} direction="column">
        <Grid
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "blue",
            borderBottom: "1px solid"
          }}>
          Gift Features
        </Grid>
        { char.spirit.gifts.map((cfs, key) => {
          return (
            <Grid key={key} container spacing={0} direction="column">
              <Grid
                style={{ 
                  fontWeight: "bold", 
                  color: "blue",
                  cursor: "pointer"
                }}
                onClick={() => {
                  setSelectedCFS(cfs);
                  setSelectedCFB(null);
                }}>
                { cfs.source && cfs.source.name } Features
              </Grid>
              { renderFeaturesForCFS(cfs) }
            </Grid>
          );  
        })}
      </Grid>
    );
  }

  const renderFeaturesForCFS = (cfs: CharacterFeatureSource) => {
    return char_util.useFeatures2(char, cfs).sort((a, b) => { 
      if (a.feature_base && b.feature_base) {
        if (+a.sort_level === +b.sort_level) {
          if (a.ancestries.length === b.ancestries.length) {
            return a.name.localeCompare(b.name);
          } else {
            return (+a.ancestries.length < +b.ancestries.length ? -1 : 1);
          }
        } else {
          return (+a.sort_level < +b.sort_level ? -1 : 1);
        }
      } else {
        return 1;
      }
    }).map((cfb, key) => {
      const alternate = key % 2 === 0;
      let className = `object_index_item clickable ${(alternate ? "alternate" : "")}`;
      const labelClassName = `labs_label ${(alternate ? "alternate" : "")}`;
  
      if (cfb.needs_attention) {
        className += " Flashing";
      }
      return (
        <Grid
          key={key}
          className={ className }
          onClick={() => {
            setSelectedCFS(cfs);
            setSelectedCFB(cfb);
          }}>
          <span className={labelClassName}>
            { cfb.name }
          </span>
        </Grid>
      );
    });
  }

  const renderSelected = () => {
    let content: any = null;
    if (selected_cfs && selected_cfb) {
      content = (
        <CharacterFeatureBaseInput
          obj={selected_cfb}
          char={char}
          source={selected_cfs}
          // onChange={(changed: CharacterFeatureBase) => {
          //   selected_cfb.calcAttention(character);
          //   char_util.repopulateCharFeatureBases(character).then(() => {
          //     onChange();
          //   });
          // }}
        />
      );
    } else if (selected_cfs) {
      content = (
        <CharacterFeatureSourceInput
          char={char}
          source={selected_cfs}
          // onChange={(do_main: boolean) => {
          //   onChange();
          // }}
        />
      );
    }
    return content;
  }

  const menu_options = ["ALL","Classes","Background","Race"];
  let extra_feats = false;
  let gifts = false;
  if (char.spirit.extra_feats.length > 0) {
    menu_options.push("Extra Feats");
    extra_feats = true;
  }
  if (char.spirit.gifts.length > 0) {
    menu_options.push("Gifts");
    gifts = true;
  }
  return (
    <Grid container spacing={0} direction="row" className="bg_black_transp">
      <Grid
        container
        spacing={0}
        direction="column"
        className="curved_border"
        style={{
          fontSize: "11px"
        }}
        size={{
          xs: 6
        }}>
        <Grid>
          <div className="centered"
            style={{
              fontSize: "13px",
              fontWeight: "bold"
            }}>
            <div>
              Features &amp; Traits
            </div>
          </div>
        </Grid>
        <Grid>
          {/* <div className="centered"> */}
            <FloatMenu
              options={menu_options}
              selected={view}
              onSelect={setView}
            />
          {/* </div> */}
        </Grid>
        { ["ALL","Class"].includes(view) &&
          renderClassFeatures()
        }
        { ["ALL","Background"].includes(view) &&
          renderBackgroundFeatures()
        }
        { ["ALL","Race"].includes(view) &&
          renderRacialFeatures()
        }
        { extra_feats && ["ALL","Extra Feats"].includes(view) &&
          renderExtraFeatFeatures()
        }
        { gifts && ["ALL","Gifts"].includes(view) &&
          renderGiftFeatures()
        }
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        { renderSelected() }
      </Grid>
    </Grid>
  );
}
